/**
 * CHRONO SESSION - AUTH CALLBACK PAGE
 * 
 * Handles the redirect from OAuth providers.
 * 1. Checks URL for session (Hash or Code)
 * 2. Sets session if needed
 * 3. Redirects to /signin (which will then show signed-in state)
 */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'

export default function AuthCallbackPage() {
  const navigate = useNavigate()
  const [status, setStatus] = useState('Processing login...')

  useEffect(() => {
    console.log('🔄 AuthCallback Mounted')
    
    const handleCallback = async () => {
      setStatus('Checking authentication...')
      // 1. Check for manual hash (Implicit Flow Fallback)
      if (window.location.hash && window.location.hash.includes('access_token')) {
        console.log('📝 Processing hash details...')
        setStatus('Processing secure token...')
        try {
          const hashParams = new URLSearchParams(window.location.hash.substring(1))
          const access_token = hashParams.get('access_token')
          const refresh_token = hashParams.get('refresh_token')
          
          if (access_token) {
            const { error } = await supabase.auth.setSession({
              access_token,
              refresh_token: refresh_token || '',
            })
            if (error) throw error
            console.log('✅ Session set manually from hash')
            setStatus('Session established!')
          }
        } catch (err) {
          console.error('Hash processing failed:', err)
          navigate('/signin?error=Hash processing failed')
          return
        }
      }

      // 2. Let Supabase settle
      setStatus('Finalizing login...')
      setTimeout(async () => {
        const { data: { session }, error } = await supabase.auth.getSession()
        
        if (session) {
          console.log('🎉 Auth successful, redirecting...')
          setStatus('Success! Redirecting...')
          navigate('/signin?source=extension') 
        } else {
          console.error('❌ No session found after redirect', error)
          navigate('/signin?error=Login failed - no session')
        }
      }, 1000) // Small delay to allow async storage writes
    }

    handleCallback()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-lg font-semibold text-gray-900">Finalizing Sign In...</h2>
        <p className="text-gray-500 text-sm mt-2">{status}</p>
      </div>
    </div>
  )
}
